import { FullscreenButton } from "./src/FullscreenButton.js";

export { FullscreenButton } from "./src/FullscreenButton.js";

customElements.define("fullscreen-button",FullscreenButton);